import { render, staticRenderFns } from "./BlogWiki.vue?vue&type=template&id=02b7cb50"
import script from "./BlogWiki.vue?vue&type=script&lang=ts"
export * from "./BlogWiki.vue?vue&type=script&lang=ts"
import style0 from "./BlogWiki.vue?vue&type=style&index=0&id=02b7cb50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports